/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AccountTaxMetric,
  HTTPValidationError,
  YtdTaxMetricsRequest,
} from '../models/index';
import {
    AccountTaxMetricFromJSON,
    AccountTaxMetricToJSON,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    YtdTaxMetricsRequestFromJSON,
    YtdTaxMetricsRequestToJSON,
} from '../models/index';

export interface GetYtdTaxMetricsRequest {
    ytdTaxMetricsRequest: YtdTaxMetricsRequest;
}

/**
 * 
 */
export class TaxMetricsApi extends runtime.BaseAPI {

    /**
     * Retrieve the year-to-date realized pnl and tax of accounts, next to their live tax rates and budget.
     */
    async getYtdTaxMetricsRaw(requestParameters: GetYtdTaxMetricsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AccountTaxMetric>>> {
        if (requestParameters.ytdTaxMetricsRequest === null || requestParameters.ytdTaxMetricsRequest === undefined) {
            throw new runtime.RequiredError('ytdTaxMetricsRequest','Required parameter requestParameters.ytdTaxMetricsRequest was null or undefined when calling getYtdTaxMetrics.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/tax-metrics/ytd`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: YtdTaxMetricsRequestToJSON(requestParameters.ytdTaxMetricsRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AccountTaxMetricFromJSON));
    }

    /**
     * Retrieve the year-to-date realized pnl and tax of accounts, next to their live tax rates and budget.
     */
    async getYtdTaxMetrics(requestParameters: GetYtdTaxMetricsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AccountTaxMetric>> {
        const response = await this.getYtdTaxMetricsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
